export default __webpack_public_path__ + "static/hero-8caf27ce543d6e63232e24a7c32011c0.jpg";